import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as QuoteOpen } from "../../../assets/images/quote-sx.svg";
import { ReactComponent as QuoteClose } from "../../../assets/images/quote-dx.svg";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import fotoPres from "../../../assets/images/gm.png";
import firmaPres from "../../../assets/images/firma-gm.png";
import bkg from "../../../assets/images/bkg-beige.png";

export default function Sezione2popup2({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  // ESC + blocco scroll quando il popup è aperto
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Lettera agli Stakeholder", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Lettera agli stakeholder"
    >
      <div
        className="
          relative
          bg-white shadow-2xl
          max-h-[90vh] w-full md:w-[1280px] overflow-y-auto overscroll-contain
        "
        // sfondo
        style={{ 
             backgroundImage: `url(${bkg})`,
            backgroundRepeat:'no-repeat', 
            backgroundPosition:'right bottom', 
            backgroundSize:'cover' 
        }}
      >
        {/* Azioni in alto a destra: badge, share, X */}
        <div className="absolute right-3 top-3 flex items-center gap-2 z-2">
          <button
            onClick={() => onShare("Sezione2popup2")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] hover:bg-[#fff] hover:text-white border border-transparent hover:border-[#0E3761] transition"
            title="Condividi"
            aria-label="Condividi"
          >
            {shareIcon ? <img src={shareIcon} alt="" className="h-4 w-4" /> : "↗"}
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] hover:bg-[#fff] hover:text-white border border-transparent hover:border-[#0E3761] transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            {closeIcon ? <img src={closeIcon} alt="Chiudi" className="h-4 w-4" /> : "✕"}
          </button>
        </div>

        {/* Contenuto */}
        <div className="py-8">
          <div className="flex flex-col gap-6">

            <div className="flex flex-col md:flex-row gap-4">

                <div className="md:w-1/3" style={{borderBottom:"2px solid #002655"}}>
                    <img
                        src={fotoPres}
                        alt="Autore"
                        className="w-full md:w-[245px] md:ml-auto pb-3"
                    />
                </div>

                <div className="md:w-2/3 relative flex items-center flex-wrap px-5 md:pr-8">
                    <QuoteOpen className="mt-1 w-6 h-6 absolute top-1 md:top-6" />
                    <div>
                      <p className="pl-0 md:pl-6 pt-12 text-[16px] md:text-[24px]">
                        Gentili Stakeholder,
                      </p>
                      <p className="pl-0 md:pl-6 text-[16px] md:text-[24px]">
                        l’anno che si è appena concluso è stato denso di eventi politici e istituzionali di rilievo che ci hanno rafforzati nella convinzione di proseguire nella strada tracciata dal nostro Gruppo, guidati dal nostro Purpose “Taking care of people for a better world, together”.
                      </p>
                    </div>
                </div>

            </div>
                    
            {/* Colonna destra: testo */}
            <div className="flex flex-col relative px-5 md:px-8">              

              {/* Paragrafi */}
              <div className="mt-1 space-y-4">
                <p className="text-[16px] md:text-[24px]">
                  Oggi le aziende sono soggette a innumerevoli pressioni, che costituiranno le sfide del prossimo futuro: quelle ambientali e sociali, la crescente necessità di un’attenta gestione del rischio e l’onerosità dei requisiti di compliance normativa.                </p>
                <p className="text-[16px] md:text-[24px]">
                  In questo scenario in continua evoluzione le aziende devono riflettere sul ruolo strategico da attribuire alle tematiche di sostenibilità per dare loro concretezza e significatività.
                </p>
                <p className="text-[16px] md:text-[24px]">
                  Per questo, in Reale Group, stiamo lavorando intensamente per sfruttare quella che consideriamo una grande opportunità di creazione di valore, integrando la sostenibilità nei nostri processi operativi, gestionali e di governance, oltre che inscrivendola nei nostri piani strategici a lungo termine.                </p>
                <p className="text-[16px] md:text-[24px]">
                  Nel 2024, abbiamo avviato importanti progettualità e assunto impegni ambiziosi in ambito di sostenibilità.  Siamo certi che questi ci consentiranno, da un lato, di restare fedeli al nostro posizionamento distintivo, dall’altro di abbracciare il cambiamento in ottica evolutiva.
                </p>
                <p className="text-[16px] md:text-[24px]">
                  Auspico che l’analisi di questo documento riesca nell’obiettivo di illustrarvi la portata di questa trasformazione.
                </p>
                <p className="text-[16px] md:text-[24px]">
                  Buona lettura!
                </p>
                 <QuoteClose className="mt-1 w-6 h-6" />
              </div>

              {/* Firma */}
              <div className="mt-8 flex flex-col items-end justify-end gap-4">
                <div className="flex flex-col text-center">
                  <div className="font-semibold text-[#0E3761]">Luca Filippone</div>
                  <div className="text-sm text-[#0E3761]">Group &  RMA General Manager</div>
                </div>
                <img
                  src={firmaPres}
                  alt="Firma Luca Filippone"
                  className="h-12 md:h-14 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}